import React from 'react';
import { Users } from 'lucide-react';
import StatusBadge from './StatusBadge';
import { parseDate } from '../../utils/dates';
import './TeamContext.css';

function TeamContext({ teamData, loading }) {
  if (loading) {
    return (
      <div className="team-context team-context-loading">
        Loading team availability...
      </div>
    );
  }

  if (!teamData || Object.keys(teamData).length === 0) {
    return null;
  }

  // Flatten and check if anyone is out
  const hasAnyoneOut = Object.values(teamData).some(people => people.length > 0);

  if (!hasAnyoneOut) {
    return (
      <div className="team-context">
        <div className="team-context-header">
          <Users size={14} />
          <span>No team members are out on selected dates</span>
        </div>
      </div>
    );
  }

  return (
    <div className="team-context">
      <div className="team-context-header">
        <Users size={14} />
        <span>Team members out on selected dates</span>
      </div>
      <div className="team-context-list">
        {Object.entries(teamData).map(([date, people]) => {
          if (people.length === 0) return null;
          return (
            <div key={date} className="team-context-date">
              <span className="team-context-date-label">
                {parseDate(date).toLocaleDateString('en-US', {
                  weekday: 'short', month: 'short', day: 'numeric'
                })}
              </span>
              <div className="team-context-people">
                {people.map((person, i) => (
                  <div key={i} className="team-context-person">
                    <span className="team-context-name">
                      {person.first_name || person.name}
                    </span>
                    {person.department && (
                      <span className="team-context-dept">{person.department}</span>
                    )}
                    <StatusBadge status={person.status} />
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TeamContext;
